var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadCaretUp = function SvgFadCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M171.698 167.901c15.683.238 23.307-19.642 11.729-31.004-11.578-11.363-35.026-35.011-42.357-42.475-7.332-7.464-18.658-6.169-25.444 0-6.786 6.169-31.73 31.744-43.138 43.26-11.408 11.515-3.6 29.982 11.853 29.982s71.675 0 87.357.237z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.992 147.363c1.562 1.555 1.041 3.806-1.173 3.795l-82.448-.427c-2.21-.011-2.724-1.275-1.146-2.823l39.597-39.868c1.577-1.547 4.13-1.534 5.684.014l39.486 39.31z",
    fill: "#FFF"
  }))));
};
export { SvgFadCaretUp as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-caret-up.41d5b011.svg";